import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { I18n } from 'react-redux-i18n';
import { withStyles } from '@material-ui/core/styles/withStyles';
import { Paper, Button, TextField, Typography } from '@material-ui/core';
import { searchInvoice } from './../../../redux/actions/tracker/invoiceActions';
import { getAuthUser } from './../../../redux/actions/authActions';
import { executionByInvoiceId, checkInvoice } from '../../../redux/actions/tracker/executionActions';
import { workflowStepList } from '../../../redux/actions/tracker/workflowstepActions';
import MsStepperLocation from './../Check/MsStepperLocation';
import PageBase from '../../../app/PageBase';
import { showToast } from '../../../redux/actions/toastrActions';

const styles = {
  btnInsert: {
    'margin-top': '5%',
  },
  paper: {
    width: '50%',
  },
  textField: {
    marginTop: 20,
    marginBottom: 20,
    marginLeft: 20,
    marginRight: 20,
    width: 200,
  },
};

class InvoiceSearch extends Component {

  static propTypes = {
    user: PropTypes.data,
  };

  constructor(props) {

    super(props);
    this.searchInvoice = this.searchInvoice.bind(this);
    this.renderExecution = this.renderExecution.bind(this);

    this.state = {
      invoiceNumber: '',
      lstExecution: {},
      wfsteps: {},
      answers: [],
    };

  }

  searchInvoice(event) {

    const user = getAuthUser();
    const { invoiceNumber } = this.state;

    const params = {
      invoiceNumber,
      companyId: user.context.idCompany,

    };

    event.preventDefault();

    searchInvoice(params).then((invoice) => {

      showToast('success', '', 'Nota carregada com sucesso');
      this.renderExecution(invoice);

    }, (e) => {

      showToast('error', '', 'Não foram encontradas notas com este número');


    });

  }

  handleChange = name => (event) => {

    this.setState({
      [name]: event.target.value,
    });

  };

  fieldHandleChange = () => (event) => {

    const { answers } = this.state;
    const name = event.target.name;
    const value = event.target.value;

    const currentIndex = answers.map(obj => obj.FieldName).indexOf(name);

    if (currentIndex === -1) {

      answers.push({ FieldName: name, answer: value });
      this.setState({ answers });

    } else {

      answers[currentIndex].answer = value;
      this.setState({ answers });

    }

  };

  renderExecution(invoice) {

    executionByInvoiceId(invoice.invoiceId)
      .then(lstExecution => workflowStepList(invoice.workflowId)
        .then(wfsteps => this.setState({ wfsteps, lstExecution })));

  }

  render() {

    const { invoiceNumber, lstExecution, wfsteps } = this.state;

    return (
      <div>
        <PageBase
          title={I18n.t('menu.workflowSearch')}
          showCreateButton={false}
          showEditButton={false}
          showDeleteButton={false}
        >
          <TextField
            id="invoiceNumber"
            label={I18n.t('fields.invoiceNumber')}
            value={invoiceNumber}
            onChange={this.handleChange('invoiceNumber')}
            style={styles.textField}
            margin="normal"
            autoComplete="true"
          />
          <Button variant="contained" color="primary" onClick={this.searchInvoice}>
            {I18n.t('button.search')}
          </Button>
          <MsStepperLocation
            data={{ lstExecution, wfsteps }}
            answers
          />


        </PageBase>

      </div>
    );

  }

}

export default withRouter(InvoiceSearch);



// WEBPACK FOOTER //
// ./src/components/tracker/Invoice/InvoiceSearch.js